import ChartDataLabels from 'chartjs-plugin-datalabels'
import TimeMeasurementLines from 'frontcore/utils/chart-pluggins/time-measurement-lines'
import {
  COLON_SEPARATOR,
  PERCENTAGE_CHAR,
} from './constants'

export const SUPER_SAD_ICON = 'supersad'
export const SAD_ICON = 'sad'
export const SMILE_ICON = 'smile'
export const DOUBT_ICON = 'doubt'
export const NOT_APPLY_ICON = 'not-apply'
export const HAPPINESS_ICON = 'happiness'
export const POKERFACE_ICON = 'pokerface'
export const MIDDLE_LINE_ICON = 'middle-line'
export const WARNING_STYLE = 'warning'
export const SUCCESS_STYLE = 'success'
export const NEUTRAL_STYLE = 'neutral'
export const DANGER_STYLE = 'danger'
export const BAR_CHART_ICON = 'barChart'
export const TREND_DOWN_ICON = 'trend-chart-down'
export const TREND_UP_ICON = 'trend-chart-up'
export const PIE_ICON = 'pie-chart'
export const BAR_CHART_TYPE = 'bar'
export const PIE_CHART_TYPE = 'pie'
export const LINE_CHART_TYPE = 'line'
export const ZERO_PERCENT = 'zero-percent'
export const TWENTY_PERCENT = 'twenty-percent'
export const TWENTY_FIVE_PERCENT = 'twenty-five-percent'
export const FORTY_PERCENT = 'forty-percent'
export const FIFTY_PERCENT = 'fifty-percent'
export const SIXTY_PERCENT = 'sixty-percent'
export const SEVENTY_FIVE_PERCENT = 'seventy-five-percent'
export const EIGHTY_PERCENT = 'eighty-percent'
export const HUNDRED_PERCENT = 'hundred-percent'
export const OK_ICON = 'check'
export const NOK_ICON = 'cross'

export const ICONS = {
  'NAIcon': NOT_APPLY_ICON,
  'SadIcon': SAD_ICON,
  'MiddleLineIcon': MIDDLE_LINE_ICON,
  'DoubtfulIcon': DOUBT_ICON,
  'SmileIcon': SMILE_ICON,
  'HappyIcon': HAPPINESS_ICON,
  'SuperSadIcon': SUPER_SAD_ICON,
  'PokerFaceIcon': POKERFACE_ICON,
  'OKIcon': OK_ICON,
  'NOKIcon': NOK_ICON,
  'BlankIcon': MIDDLE_LINE_ICON,
  '0Icon': ZERO_PERCENT,
  '20Icon': TWENTY_PERCENT,
  '25Icon': TWENTY_FIVE_PERCENT,
  '40Icon': FORTY_PERCENT,
  '50Icon': FIFTY_PERCENT,
  '60Icon': SIXTY_PERCENT,
  '75Icon': SEVENTY_FIVE_PERCENT,
  '80Icon': EIGHTY_PERCENT,
  '100Icon': HUNDRED_PERCENT,
}

export const DEFAULT_COLORS =  {
  'grey': '#959798',
  'red': '#ec4c47',
  'green': '#47b881',
  'blue': '#1070ca',
  'yellow': '#f6d053',
  'orange': '#d8822a',
  'celeste': '#14b4d0',
}

export const CHART_DATA_LABEL_PLUGIN = 'ChartDataLabels'
export const CHART_TIME_MEASUREMENTS_LINES_PLUGIN = 'timeMeasurementLines'
export const NUMBER_OF_DECIMALS_TO_ROUND = 2

export const AVAILABLE_CHART_PLUGINS = [
  CHART_DATA_LABEL_PLUGIN, CHART_TIME_MEASUREMENTS_LINES_PLUGIN,
]

export const AVAILABLE_PLUGINS_MAP = {
  [CHART_DATA_LABEL_PLUGIN]: ChartDataLabels,
  [CHART_TIME_MEASUREMENTS_LINES_PLUGIN]: TimeMeasurementLines,
}

export const DECIMAL_SCALE = {
  ticks: {
    beginAtZero: true,
    userCallback (label) {
      if (Math.floor(label) === label) {
        return label
      }
    },
  },
}

export const PERCENTAGE_SCALE = {
  ticks: {
    min: 0,
    max: 100,
    stepSize: 20,
    callback (value) {
      return value + PERCENTAGE_CHAR
    },
  },
}

export const PERCENTAGE_TOOLTIP = {
  enabled: true,
  mode: 'single',
  callbacks: {
    label (tooltipItem, data) {
      const label = data.labels[tooltipItem.index]
      const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
      return label + COLON_SEPARATOR + value.toFixed(NUMBER_OF_DECIMALS_TO_ROUND) + PERCENTAGE_CHAR
    },
  },
}

export const DEFAULT_TOOLTIP = {
  mode: 'x',
  callbacks: {
    label (tooltipItem, data) {
      const label = data.datasets[tooltipItem.datasetIndex].label
      const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
      const roundedValue = Number.isInteger(value) ? value : value.toFixed(NUMBER_OF_DECIMALS_TO_ROUND)
      return label + COLON_SEPARATOR + roundedValue
    },
  },
}
